(function () {

    a3_pilot_reports.directive('releaseWarning', releaseWarning);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name releaseWarning
   * @restrict E
   * @description
   *   Soft rules alert in release
   * @example
   *   Usage:
   *   <release-warning></release-warning>
   * @ngInject
   */

    function releaseWarning() {
        function link(scope, attrs) {

            scope.warningTrainees = scope.trainees.filter(x => !x.Session.Absent && x.ShowReleaseWarning);
            scope.filterSelectedTrainee = filterSelectedTrainee;

            function filterSelectedTrainee(){
                return function( trainee ) {
                    var showTrainee = false;
                    if(scope.selectedTrainee){
                        showTrainee = trainee.CrewId == scope.selectedTrainee.CrewId;
                    }
                    return showTrainee;
                };
            }


        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/releaseWarning.tpl.html",
            scope : false,
            terminal: true,
            link: link
        }
    }
})();